module.exports = __webpack_public_path__ + "views/editExchange.0fa6a173f65c22bfeb4d5a2d8aed897f.html";